import { useEffect, useState } from "react";
import styles from "./customerData.module.css";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  customersApi,
  useGetCustomersQuery,
} from "../../features/api/customers/customersApi";
import { AddCustomer } from "../addCustomer/AddCustomer";

export const CustomerData = () => {
  const [key, setKey] = useState("Customer List");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Pagination States
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [customers, setCustomers] = useState([]);

  // Fetching data from API
  const { data, isLoading, isError } = useGetCustomersQuery({
    page: pageNo,
    size: pageSize,
    companyName,
  });

  // Function to fetch next page of products
  const getNextPage = (page) => {
    dispatch(
      customersApi.endpoints.getCustomers.initiate({
        page: page,
        size: pageSize,
        companyName,
      })
    );
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 0) {
      setPageNo(newPage);
      getNextPage(newPage);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPageSize(newSize);
    setPageNo(0); // Reset to first page when page size changes
    getNextPage(0); // Fetch data for the first page with new page size
  };

  // When data is fetched, update the customers state
  useEffect(() => {
    if (data?.content) {
      setCustomers(data.content);
      setTotalPages(data.totalPages);
    }
  }, [data]);

  return (
    <div className="container pt-5">
      <Tabs
        id="controlled-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="Customer List" title="Customer List">
          <div className={styles.tableContainer}>
            {isLoading ? (
              <p>Loading...</p>
            ) : isError ? (
              <p>Error fetching data</p>
            ) : (
              <>
                <table className={styles.customTable}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Company Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.length > 0 ? (
                      customers.map((customer, idx) => (
                        <tr
                          key={customer.id}
                          onClick={() => navigate(`/customer/${customer.id}`)}
                        >
                          <td>{pageNo * pageSize + idx + 1}</td>
                          <td className={styles.capitalize}>
                            {customer.companyName}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className={styles.noData}>
                          No customer found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination Controls */}
                <div className={styles.pagination}>
                  {/* Page Size Selector */}
                  <div className={styles.pageSizeSelector}>
                    <label htmlFor="pageSize">Page Size: </label>
                    <select
                      id="pageSize"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                    </select>
                  </div>
                  <button
                    onClick={() => handlePageChange(pageNo - 1)}
                    disabled={pageNo === 0}
                  >
                    Previous
                  </button>
                  <span>
                    Page {pageNo + 1} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(pageNo + 1)}
                    disabled={
                      !data?.content?.length || totalPages === pageNo + 1
                    }
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </Tab>

        <Tab eventKey="Add Customer" title="Add Customer">
          <AddCustomer onSuccess={() => setKey("Customer List")} />
        </Tab>
      </Tabs>
    </div>
  );
};
